module.exports = __webpack_public_path__ + "static/media/emo_sprite.a279a9ce.png";